module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('v-card-text', [_c('v-container', {
    staticClass: "grey lighten-4",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('h2', [_vm._v("Os seguintes recursos estão disponíveis em caso de dúvidas:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Perguntas Frequentes:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Respostas para as dúvidas mais comuns sobre o sistema e procedimentos realizados pela PROEX.")]), _vm._v(" "), _c('p', [_vm._v("Em atualização")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Orientações Gerais:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique nos links abaixo:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://ods.ufes.br/",
      "target": "_blank"
    }
  }, [_vm._v("UFES - Objetivos de Desenvolvimento Sustentável")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://brasil.un.org/pt-br/sdgs",
      "target": "_blank"
    }
  }, [_vm._v("Nações Unidas - Objetivos de Desenvolvimento Sustentável no Brasil")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Fale Conosco:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("\n                      Dúvidas sobre preenchimento devem ser encaminhadas para\n                      "), _c('a', {
    attrs: {
      "href": "mailto:suporte.proex@ufes.br"
    }
  }, [_vm._v("suporte.proex@ufes.br")]), _vm._v(".\n                      Já problemas no portal podem ser direcionados para\n                      "), _c('a', {
    attrs: {
      "href": "https://atendimento.ufes.br/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n                        atendimento.ufes.br.\n                      ")])])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3544185a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ajuda/ajuda.vue
// module id = 355
// module chunks = 0